import { StoreDetailSchemaType } from "@repo/core/services/entities/Proposals";

export enum StoreSelectorVariantEnum {
  SHOPKEEPER = "shopkeeper",
  BOTH = "BOTH"
}
export interface StoreSelectorProps {
  selectedStore: StoreDetailSchemaType | null;
  onSelectStore: () => void;
  enableSelectStore: boolean;
  variant?: StoreSelectorVariantEnum;
}
